<template>
  <!-- Mobile Only -->
  <div class="page-title py-5 bg-custom-gradient position-relative">
    <!-- User -->
    <div class="user d-lg-none d-flex mt-5 align-items-center justify-content-center flex-column position-absolute top-100 start-50 translate-middle w-100 px-3">
      <div class="avatar mt-lg-0 mt-3 position-relative">
        <img src="@/assets/images/msaaq.svg" width="152" alt="" />
      </div>
      <div class="d-flex align-items-center mt-1">
        <div class="fs-6 text-primary fw-bold">مساق</div>
      </div>
      <div class="fs-14px text-secondary text-center mb-5">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</div>
    </div>
  </div>
  <!-- End mobile -->

  <div class="container">
    <!-- Mobile -->
    <div class="clearfix d-lg-none d-block"></div>
    <div class="d-lg-none d-block border-top border-2 my-3"></div>
    <!-- end Mobile only -->
    <div class="my-lg-5 my-0"></div>
    <div class="row gap-3 meeting-body pb-lg-3">
      <div class="col-12 mx-auto px-0">
        <!-- Desktop Only -->
        <div class="bg-custom-gradient meeting-card d-lg-flex d-none align-items-center gap-3 py-3">
          <img src="@/assets/images/userbig.png" class="mx-3" width="90" alt="" />
          <div class="d-flex flex-column">
            <span class="fs-4 text-white fw-bold">مدحت عودة</span>
            <span class="fs-14px text-white w-75">هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى</span>
          </div>
        </div>
      </div>
      <div class="col-12 mx-auto">
        <div class="d-flex bg-white rounded-12px align-items-center border border-2 p-3">
          <div class="d-flex flex-column align-items-center px-3">
            <span class="fw-bold text-primary">الاثنين</span>
            <span class="fs-4 text-primary">13</span>
          </div>
          <div class="d-flex flex-column section-seperator px-3">
            <img src="@/assets/images/zm-02_2x.png" width="44" alt="" />
            <span class="text-dark fs-4">12:00</span>
            <span class="text-secondary fs-12px">مدة الإجتماع : 30د</span>
          </div>
          <button class="btn d-flex flex-column align-items-center ms-auto opacity-50">
            <img src="@/assets/images/pen.svg" alt="" />
            <span class="text-secondary">تعديل</span>
          </button>
        </div>
      </div>
      <div class="col-12 mx-auto">
        <div class="my-3">
          <h5 class="text-dark fw-bold fs-14px mb-3">لكي يكون الاجتماع اكثر فائدة اجب على هذه الاسئلة</h5>
          <div class="mb-3">
            <label class="fs-14px text-dark">الإسم</label>
            <input type="text" class="form-control bg-white" placeholder="مثال: مدحت عودة" />
          </div>
          <div class="mb-3">
            <label class="fs-14px text-dark">البريد</label>
            <input type="email" class="form-control bg-white" placeholder="test@test.com" />
          </div>
          <div class="mb-3">
            <div class="position-relative mb-2" v-for="item in list" :key="item">
              <input type="email" class="form-control bg-white mt-2 text-secondary py-3" placeholder="email@emai.com" />
              <button type="button" class="btn text-danger fw-bold text-decoration-underline position-absolute top-50 start-0 translate-middle ms-5" @click="removeAt(index)">إزالة</button>
            </div>
            <div class="d-flex bg-white rounded-12px align-items-center border border-2 p-3 gap-2">
              <button @click="addNewInput" class="btn">
                <img src="@/assets/images/plus.svg" width="16" alt="" />
              </button>

              <div class="d-flex flex-column">
                <span class="fs-14px fw-bold">إضافة ضيف</span>
                <span class="fs-12px text-secondary">هل سيحضر الإجتماع معنا احد آخر؟</span>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="fs-14px text-dark">من هم المنافسين لك في المجال؟</label>
            <textarea class="form-control bg-white" placeholder="اكتب اجابتك هنا"></textarea>
          </div>
          <div class="mb-3">
            <label class="fs-14px text-dark">لماذا تريد استشارتي؟</label>
            <textarea class="form-control bg-white" placeholder="اكتب اجابتك هنا"></textarea>
          </div>
          <div class="mb-3">
            <label class="fs-14px text-dark">هل انا الأفضل؟</label>
            <textarea class="form-control bg-white" placeholder="اكتب اجابتك هنا"></textarea>
          </div>
          <div class="d-grid">
            <router-link class="btn btn-primary fw-bold rounded-pill" :to="{name: 'SuccessPage'}">التالي</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let id = 0
import {ref} from '@vue/reactivity'
export default {
  setup() {
    const removeAt = (idx) => {
      list.value.splice(idx, 1)
    }
    const addNewInput = () => {
      id++
      list.value.push({id, email: ''})
    }
    const list = ref([])

    return {list, removeAt, addNewInput}
  },
}
</script>

<style>
</style>